/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailTemplate } from '../../models/email-template';
import { EmailTemplateApiRespModel } from '../../models/email-template-api-resp-model';

export interface ApiSupportEmailTemplateEditPost$Params {
      body?: EmailTemplate
}

export function apiSupportEmailTemplateEditPost(http: HttpClient, rootUrl: string, params?: ApiSupportEmailTemplateEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailTemplateApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiSupportEmailTemplateEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmailTemplateApiRespModel>;
    })
  );
}

apiSupportEmailTemplateEditPost.PATH = '/api/Support/EmailTemplate/Edit';
